module.exports = require('./helpers/bundle-url').getBundleURL('1DUm8') + "wallet.a022815f.png";